import {
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import "./styles.scss"
import { CustomTooltipBarometer } from "../Tooltip";
import { isJson } from "../../core/utils/jsonVerify";

const formatData = (data = []) => {
  return Array.isArray(data) ? data?.map((item, index) => {
    const codes = item?.codes && isJson(item?.codes) ? JSON.parse(item.codes) : []; 
    
    return {
      x: parseFloat(item.details?.Ecologico || item.summary['Biológico'] || 0).toFixed(0),
      y: parseFloat(item.details?.Humano || item.summary['Químico'] || 0).toFixed(0),
      user: item?.user || [],
      xkey: `point-${(parseFloat(item.details?.Ecologico || item.summary['Biológico'] || 0).toFixed(0) + index) || index}`,
      ykey: `point-${(parseFloat(item.details?.Humano || item.summary['Químico'] || 0).toFixed(0) + index) || index}`,
      codes
    }
  }) : []
}

export const BarometerChart = ({ width, height, data }) => {
  const array = [
    { id: 4, label: 'Insustentável', color: '#FF0101' },
    { id: 3, label: 'Quase Insustentável', color: '#FF8C02' },
    { id: 2, label: 'Intermediário', color: '#FFCC03' },
    { id: 1, label: 'Quase Sustentável', color: '#42A67C' },
    { id: 0, label: 'Sustentável', color: '#0B7348' },
  ];

  return (
    <div className="div-barometer-chart">
      <div className="div-group">
        <div className={`div-chart`}>
          {array.map((item, index) => {
            const widthReal = width - 70;
            const heightReal = height - 40;
            const style = {
              right: 1,
              top: 5,
              width: index ? widthReal - (widthReal / 5) * index : widthReal,
              height: index ? heightReal - (heightReal / 5) * index : heightReal,
              background: item.color,
              // zIndex: array && array.length - index,
            }
            return <div key={`item-${index}`} className="bar" style={style} />
          })}
        </div>
        <div>
          <ResponsiveContainer width={width} height={height} >
            <ScatterChart
              style={{ fontSize: '12px', zIndex: 9999 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                ticks={[0, 20, 40, 60, 80, 100]}
                type="number"
                dataKey="x"
                //key={(entry) => entry.xkey}
                name={(data && data[0])}
                label={{
                  value: (data && data[0] && data[0].summary['Biológico']) ? 'Biológico' : "Bem-estar ecológico",
                  position: "insideBottom",
                  offset: 0,
                  fill: "#2b824f"
                }}
              />
              <YAxis
                ticks={[0, 20, 40, 60, 80, 100]}
                type="number"
                dataKey="y"
                //key={(entry) => entry.ykey}
                name={(data && data[0])}
                label={{
                  value: (data && data[0] && data[0].summary['Químico']) ? 'Químico' : "Bem-estar humano",
                  angle: -90,
                  fill: '#2b824f'
                }}
              />

              <Tooltip content={<CustomTooltipBarometer/>} cursor={{ strokeDasharray: "3 3" }} />
              <Scatter
                name="esm-dots"
                data={formatData(data)}
              >
                {Array.isArray(data) && data.map((entry, index) => {
                  return <Cell
                    key={`cell-${index}`}
                    fill={entry.color || "#8884d8"}
                  />
                })}
              </Scatter>
            </ScatterChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  )
}